import React from 'react';

export default function formatErrorToastMessage(message: string, traceId: string): JSX.Element {
    return (
        <>
            <div>
                {message}
                <br />
                <span className="small-text">
                    {`(${window.sv_resource.get('plf_error_reference_id')}: ${traceId})`}
                </span>
            </div>
        </>
    );
}
